<template>
    <PlanbordGridContainer class="planbord-budget-table" v-if="hasBudget" :informationColumns="informationColumns" :dayColumns="dayColumns" :hourBalanceColumns="hourBalanceColumns" :compact="compact">
        <BudgetHead :roster="roster" :budget="budget" />
        <BudgetBody :roster="roster" :budget="budget" :budgetDayCounters="budgetDayCounters" />
    </PlanbordGridContainer>
</template>

<script lang="ts">
    import BudgetHead from '@/components/Planbord/Budget/BudgetHead.vue';
    import BudgetBody from '@/components/Planbord/Budget/BudgetBody.vue';

    import {RosterData, BudgetDayCounters} from '@/types/types';
    import {Budget} from '@cquential/api';
    import PlanbordGridContainer from '@/components/Planbord/PlanbordGridContainer.vue';
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component({
        components: {
            BudgetHead,
            BudgetBody,
            PlanbordGridContainer,
        },
    })
    export default class BudgetTable extends Vue {
        @Prop({required: true}) public roster!: RosterData;
        @Prop({required: true}) public budget!: Budget;
        @Prop({default: {}}) public budgetDayCounters!: BudgetDayCounters;
        @Prop({type: Number, required: true}) public informationColumns!: number;
        @Prop({type: Number, required: true}) public dayColumns!: number;
        @Prop({type: Number, required: true}) public hourBalanceColumns!: number;
        @Prop({type: Boolean}) public compact!: boolean;

        public get hasBudget(): boolean {
            return this.budgetDayCounters
                && !!this.budget.amounts
                && this.budget.amounts.length > 0;
        }
    }
</script>

<style lang="scss" scoped>
    .planbord-budget-table {
        margin-bottom: 1rem;
    }
</style>
